import map from "lodash/map";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Table from "../../Common/Tables/BaseTable";
import NasjonerModal from "./UpdateModals/NasjonerModal";

import { getNasjoner } from "../../../actions/nasjonerActions";
import * as title from "../../../constants/titles";

export default function NasjonerList({ authorizedToCreateAndEdit }) {
  const nasjoner = useSelector((state) => state.nasjoner);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = title.grunndataNasjoner;
    dispatch(getNasjoner());
  }, [dispatch]);

  const headerRow = ["Kode", "Navn", ""];
  return (
    <div className="table-wrapper-horizontal-scroll">
      <Table id="nasjon-liste" headerRow={headerRow} defaultStyle striped>
        <tbody>
          {map(nasjoner, (nasjon) => (
            <tr key={`nasjonerTableBodyTr${nasjon.id.toString()}`}>
              <td>{nasjon.kode}</td>
              <td>{nasjon.navn}</td>
              <td>
                {authorizedToCreateAndEdit && <NasjonerModal nasjon={nasjon} />}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
